<template>
  <div class="relative overflow-hidden my-20">
    <div
      class="container absolute left-1/2 top-4 transform -translate-x-1/2 flex-row flex items-center justify-between"
    >
      <h2 class="mr-auto fluid-xl leading-tight font-medium">{{ heading }}</h2>
      <button
        v-if="showAllProducts"
        aria-label="close"
        class="focus:outline-none w-12 h-12 fluid-3xl leading-tightest"
        @click="toggleSliders"
      >
        ×
      </button>
    </div>
    <Expandable v-if="products && products.length" :open="showAllProducts">
      <div class="flex container flex-row flex-wrap mt-20 -mx-4">
        <ExercisesByProductSliderImage
          v-for="product in products"
          :key="product.id"
          class="md:w-1/3 lg:w-1/5 w-1/2 px-4"
          v-bind="product"
          data-testid="flex-cell"
        />
      </div>
    </Expandable>
    <Expandable v-if="products && products.length" :open="showSlider">
      <CardSlider :breakpoints="breakpoints">
        <ExercisesByProductSliderImage
          v-for="product in products"
          :key="product.id"
          data-testid="slide"
          v-bind="product"
        />
      </CardSlider>
    </Expandable>
    <div class="flex flex-row justify-end container">
      <button v-if="showSlider" class="mt-6" @click="toggleSliders">
        {{ $t('exercises.allProducts') }}
        <InlineArrowIcon class="inline h-2" />
      </button>
    </div>
  </div>
</template>
<script>
import InlineArrowIcon from '@/components/icons/InlineArrowIcon';
import ExercisesByProductSliderImage from '@/components/exercises/ExercisesByProductSliderImage';
import CardSlider from '@/components/common/CardSlider';
import Expandable from '~/components/common/Expandable';

export default {
  components: {
    Expandable,
    CardSlider,
    InlineArrowIcon,
    ExercisesByProductSliderImage,
  },
  props: {
    heading: {
      type: String,
      default: '',
    },
    productPages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showSlider: true,
      showAllProducts: false,
      breakpoints: [
        {
          minWindowWidth: 0,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
        {
          minWindowWidth: 600,
          slidesToShow: 5,
          slidesToScroll: 5,
        },
      ],
    };
  },
  computed: {
    products() {
      return this.productPages.map((p) => ({
        id: p.id,
        alt: p.alt ? p.alt : p.image?.length ? p.image[0]?.title : null,
        imageSrc: (p.image?.length && p.image[0]?.url) || null,
        label: p.label,
        to: p.productPage.length && p.productPage[0]?.uri ? this.$localeRootPath(p.productPage[0]?.uri) : null,
      }));
    },
  },
  methods: {
    toggleSliders() {
      this.showSlider = !this.showSlider;
      this.showAllProducts = !this.showAllProducts;
    },
  },
};
</script>
